import QueryString from 'qs';

const C25_PLAN_CODES = [
  'monthly',
  'yearly',
  'edu20',
  'business_monthly',
  'business_yearly',
];

export const uiCategoryMap = {
  zm_wbd: "zwbbasic",
  zwb_plus: "zwbplus",
  zeud: 'eventsaas',
  zecsu: 'eventsaascore',
  zo_pro: 'pro',
  zeah: 'eventsaas-additionalhost',
  zeace: 'eventsaas-additionalcoeditor',
  zecah: 'eventsaascore-additionalhost',
  zecace: 'eventsaascore-additionalcoeditor',
  zecco: 'eventsaascore',
  zeco: 'eventsaas',
}

export const isC25Plan = (subscriptions = []) => {
  return subscriptions.findIndex(item => C25_PLAN_CODES.indexOf(item.plan_code) !== -1) !== -1;
}

export const getC25Plan = (subscriptions = []) => {
  return subscriptions.find(item => C25_PLAN_CODES.indexOf(item.plan_code) !== -1);
}
export const isIncreasePriceForPH = () => {
  const promotionalKeywords = ['cartid', 'coupon', 'persistCoupon', 'jointsale', 'referralCode’,’generateCartId'];
  const query = QueryString.parse(location.search.slice(1));
  return window.newBillingConfig.isIncreasePriceForPH && !promotionalKeywords.some(keyword => query[keyword]);
};

